import React, { forwardRef } from 'react';
import type { ButtonProps as ChakraButtonProps, IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react';
import { AbsoluteCenter, Button as ChakraButton, IconButton as ChakraIconButton, Span, Spinner } from '@chakra-ui/react';

interface ButtonLoadingProps {
  loading?: boolean;
  loadingText?: React.ReactNode;
}

export interface ButtonProps extends ChakraButtonProps, ButtonLoadingProps {}

export type { ChakraIconButtonProps as IconButtonProps };

export const IconButton = forwardRef<HTMLButtonElement, ChakraIconButtonProps>((props, ref) => (
  <ChakraIconButton ref={ref} {...props} />
));

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { loading, disabled, loadingText, children, colorScheme, ...rest } = props;
  const colorSchemeSupport = colorScheme ? { colorPalette: colorScheme } : {}; // Legacy support for colorScheme
  return (
    // @ts-ignore
    <ChakraButton disabled={loading || disabled} ref={ref} {...colorSchemeSupport} {...rest}>
      {}
      {loading && !loadingText ? (
        <>
          <AbsoluteCenter display='inline-flex'>
            <Spinner size='inherit' color='inherit' />
          </AbsoluteCenter>
          <Span opacity={0}>{children}</Span>
        </>
      ) : loading && loadingText ? (
        <>
          <Spinner size='inherit' color='inherit' />
          {loadingText}
        </>
      ) : (
        children
      )}
    </ChakraButton>
  );
});
